import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { NoAuthGuard } from './no-auth.guard';
import { MaintenanceGuard } from './maintenance.guard';

const routes: Routes = [
  {
    path: 'maintenance',
    loadChildren: () =>
      import('./maintenance/maintenance.module').then((m) => m.MaintenancePageModule),
  },
  {
    path: '',
    canActivate: [MaintenanceGuard],
    canActivateChild: [MaintenanceGuard],
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomePageModule),
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'user-search',
        loadChildren: () =>
          import('./user-search/user-search.module').then(
            (m) => m.UserSearchPageModule
          ),
      },
      {
        path: 'promo-list',
        loadChildren: () =>
          import('./promo-list/promo-list.module').then(
            (m) => m.PromoListPageModule
          ),
      },
      {
        path: 'promo-details',
        loadChildren: () =>
          import('./promo-details/promo-details.module').then(
            (m) => m.PromoDetailsPageModule
          ),
      },
      {
        path: 'cruise-detail',
        loadChildren: () =>
          import('./cruise-detail/cruise-detail.module').then(
            (m) => m.CruiseDetailPageModule
          ),
      },
  // {
  //   path: 'cruise-details',
  //   loadChildren: () =>
  //     import('./cruise-details/cruise-details.module').then(
  //       (m) => m.CruiseDetailsPageModule
  //     ),
  // },
      {
        path: 'booking-mail/:id',
        loadChildren: () =>
          import('./booking-mail/booking-mail.module').then(
            (m) => m.BookingMailPageModule
          ),
      },
  // {
  //   path: 'image-database',
  //   loadChildren: () =>
  //     import('./image-database/image-database.module').then(
  //       (m) => m.ImageDatabasePageModule
  //     ),
  // },
  // {
  //   path: 'image-gallery',
  //   loadChildren: () =>
  //     import('./image-gallery/image-gallery.module').then(
  //       (m) => m.ImageGalleryPageModule
  //     ),
  // },
  // {
  //   path: 'netfare-view',
  //   loadChildren: () =>
  //     import('./netfare-view/netfare-view.module').then(
  //       (m) => m.NetfareViewPageModule
  //     ),
  // },
      {
        path: 'profile',
        loadChildren: () =>
      import('./profile/profile.module').then((m) => m.ProfilePageModule),canActivate: [AuthGuard],
      },
  // {
  //   path: 'quote-view',
  //   loadChildren: () =>
  //     import('./quote-view/quote-view.module').then(
  //       (m) => m.QuoteViewPageModule
  //     ),
  // },
      {
        path: 'register',
        loadChildren: () =>
      import('./register/register.module').then((m) => m.RegisterPageModule),canActivate: [NoAuthGuard],
      },
      {
        path: 'user-landing',
        loadChildren: () =>
          import('./user-landing/user-landing.module').then(
            (m) => m.UserLandingPageModule
          ),
      },
      {
        path: 'company',
        loadChildren: () =>
          import('./company/company.module').then((m) => m.CompanyPageModule),
      },
      {
        path: 'blocking-details',
    loadChildren: () => import('./blocking-details/blocking-details.module').then( m => m.BlockingDetailsPageModule),canActivate: [AuthGuard],
      },
      {
        path: 'reset-password/:token',
    loadChildren: () => import('./reset-password/reset-password.module').then( m => m.ResetPasswordPageModule)
      },
      {
        path: 'resource-centre',
    loadChildren: () => import('./resource-centre/resource-centre.module').then( m => m.ResourceCentrePageModule)
      },
      {
        path: 'update-pax-details/:token',
    loadChildren: () => import('./update-pax-details/update-pax-details.module').then( m => m.UpdatePaxDetailsPageModule),
      },
      {
        path: '**',
        redirectTo: 'home',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
